import { DisplayPosition } from '@/type/display-position';
import { getDateFormatSetterSnippet, getDatePrecisionSetterSnippet, getMixedSetterSnippet, } from '@/common/manager/setter-snippet';
// import {
//   CnDatePickerPro,
//   componentMap as formComponentMap,
// } from '@cainiaofe/cn-ui-m';
const dateModeStatic = 'picker';
export function getDateModeSetterSnippet(config = {}) {
    return {
        name: 'mode',
        title: '模式选择',
        display: 'inline',
        setter: {
            componentName: 'RadioGroupSetter',
            props: {
                options: [
                    { title: '普通模式', value: 'picker' },
                    { title: '日历模式', value: 'calendar' },
                ],
            },
            initialValue: dateModeStatic,
        },
        ...config,
    };
}
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '日期选择',
    componentName: 'CnDatePickerPro',
    // component: CnDatePickerPro,
    // formComponent: formComponentMap.CnDatePickerPro,
    getDefaultProps: () => {
        return {
            precision: 'day',
        };
    },
    getPrototypeList: () => {
        return [
            getDateModeSetterSnippet(),
            getDatePrecisionSetterSnippet({
                condition(prop) {
                    return prop?.parent?.getPropValue?.('mode') === dateModeStatic;
                },
            }),
            {
                name: 'outputFormat',
                title: '输出格式',
                display: 'inline',
                condition(prop) {
                    return prop?.parent?.getPropValue?.('mode') === dateModeStatic;
                },
                setter: getMixedSetterSnippet({
                    setters: [
                        {
                            title: '快捷选择',
                            componentName: 'SelectSetter',
                            props: {
                                options: [
                                    {
                                        label: '时间戳',
                                        value: '',
                                    },
                                    {
                                        label: 'YYYY',
                                        value: 'YYYY',
                                    },
                                    {
                                        label: 'YYYY-MM',
                                        value: 'YYYY-MM',
                                    },
                                    {
                                        label: 'YYYY-MM-DD',
                                        value: 'YYYY-MM-DD',
                                    },
                                    {
                                        label: 'YYYY-MM-DD HH',
                                        value: 'YYYY-MM-DD HH',
                                    },
                                    {
                                        label: 'YYYY-MM-DD HH:mm',
                                        value: 'YYYY-MM-DD HH:mm',
                                    },
                                    {
                                        label: 'YYYY-MM-DD HH:mm:ss',
                                        value: 'YYYY-MM-DD HH:mm:ss',
                                    },
                                ],
                            },
                        },
                        {
                            componentName: 'StringSetter',
                            title: '手动设置',
                        },
                    ],
                }),
            },
            getDateFormatSetterSnippet(),
            // {
            //   name: 'showTime',
            //   title: '显示时间',
            //   display: 'inline',
            //   setter: 'BoolSetter',
            //   // condition(prop) {
            //   //   return condition(prop, 'DatePicker', 'componentName') && prop?.parent?.getPropValue?.('type') === 'date';
            //   // },
            // },
        ];
    },
};
